import simpleSoilAttribute from './simpleSoilAttribute';

export const DRAINAGE_CLASS = simpleSoilAttribute({
  key: 'Drainage Class',
  ruleId: '44',
  shortFormData: { AggregationMethod: 'Dominant Condition' },
});
